<template>
  <v-chip v-if="visible" label small class="px-2" :color="completada ? 'green lighten-2' : 'orange'"
    text-color="white" :disabled="!completada" :link="completada" :href="completada ? autorizacion.url : undefined"
    target="_blank" rel="noopener noreferrer" :title="titulo" :aria-label="titulo">
    €
  </v-chip>
</template>

<script>
export default {
  props: {
    autorizacion: { type: Object, default: null },
  },
  computed: {
    completada() {
      return !!(this.autorizacion && (this.autorizacion.completado || this.autorizacion.completado_at));
    },
    visible() {
      return !!(this.autorizacion && (this.autorizacion.enviado_at || this.completada));
    },
    titulo() {
      return this.completada ? 'Ver autorización de tarjeta completada' : 'Autorización de tarjeta enviada, pendiente de completar';
    },
  },
};
</script>
